import React from 'react'
import '../experience/exp.css';
import {BsPatchCheckFill} from 'react-icons/bs';
import {BsCircle} from 'react-icons/bs';
import {RiMapPin3Fill} from 'react-icons/ri';
import {BsStarFill} from 'react-icons/bs';
import {BsStarHalf} from 'react-icons/bs';
import {BsStar} from 'react-icons/bs';
import {SiGooglemaps} from 'react-icons/si';
function Exp() {
  return (
    <section id='exp'>
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>
      <div className="exp_container container">
      <div className="exp_work">
          <h3>Experience</h3>
          <div className="work_exp">
            <div className='work_exp_details_icons'>
            <SiGooglemaps className=''/>
            </div>
            <article className="work_exp_details">
          
              <div className='companyName'>
             
              <h4 >Clover Bay Technologies Pvt. Ltd.</h4>
              <h6 className='designation'>Associate Software Development Engineer</h6>
              <small className='text-exp'> June 2022 to Present</small>
             <div>
             <small className='text-light'><span className='dot_color'>●</span> Building asynchronous APIS and Kafka consumers using python and
MongoDB, for e-commerce to be launched with a lot of rare functionalities</small>
              
             </div>
             <div>
             <small className='text-light'><span className='dot_color'>●</span> Built asynchronous, non-blocking, and event-driven APIs using Java
Reactive-Spring-Boot and PostgreSQL</small>
             </div>
            

              </div>
          </article>
          
          <article className="work_exp_details">
          <div className='work_exp_details_icons'>
            <SiGooglemaps className=''/>
            </div>
          
              <div className='companyName'>
             
              <h4 >Highradius Corporation</h4>
              <h6 className='designation'>Machine Learning Intern</h6>
              <small className='text-exp'>Aug 2021 to May 2022 (10 months)</small>
             <div>
             <small className='text-light'><span className='dot_color'>●</span> Worked with Regression Algorithm for prediction of target based on 
              correlations between dependent and independent variables</small>
             </div>
             <div>
             <small className='text-light'><span className='dot_color'>●</span> Worked with Regression Algorithm for prediction of target based on 
              correlations between dependent and independent variables</small>
             </div>
             <div>
             <small className='text-light'><span className='dot_color'>●</span> Worked with Regression Algorithm for prediction of target based on 
              correlations between dependent and independent variables</small>
             </div>

              </div>
          </article>
          <article className="work_exp_details">
          <SiGooglemaps className='work_exp_details_icons'/>
              <div className='companyName'>
              <h4 >Indian Nation Youth Foundation</h4>
              <h6 className='designation'>Web Developer Intern</h6>
              <small className='text-exp'>Jan 2021 to March 2021 (3 months)</small>
              <div>
              <small className='text-light'><span className='dot_color'>●</span> Worked on making some changes to the website and 
              upgrading the website functionality using WordPress</small>
                  </div>
              </div>
          </article>
       
          </div>
        
        </div>
        
        <div className="exp_backend">
          <h3>Backend</h3>
          <div className="exp_content">
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Java</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarFill/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Spring Boot</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Sanic</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Python</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Asyncio</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article>
          
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>PostgreSQL</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Apache Kafka</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Node js</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStar/></small>
              </div>
          </article><article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Express</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStar/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Laraval</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>PHP</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStar/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Mysql</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>MongoDB</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStar/></small>
              </div>
          </article>
          </div>
        </div>
        <div className="exp_others">
          <h3>Others</h3>
          <div className="exp_content">
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Machine Learning</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStar/></small>
              </div>
          </article><article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Android</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article><article className="exp_details">
              <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Github</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article><article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Heroku</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStar/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>J2EE</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarFill/></small>
              </div>
          </article>
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4> Data Visualization</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article>


         
          </div>
        </div>

        <div className="exp_frontend">
          <h3>Frontend</h3>
          <div className="exp_content">
          <article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>HTML</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarFill/></small>
              </div>
          </article><article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>React</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article><article className="exp_details">
              <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>Javascript</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarHalf/></small>
              </div>
          </article><article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>jQuery</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStar/></small>
              </div>
          </article><article className="exp_details">
          <BsPatchCheckFill className='exp_details_icons'/>
              <div>
              <h4>CSS</h4>
              <small className='text-light'><BsStarFill/><BsStarFill/><BsStarFill/></small>
              </div>
          </article>
          </div>
        </div>
     

      </div>

    </section>
  )
}

export default Exp
